import { UIHeading2, UIHeading4, UIText2 } from '@cian/ui-kit';
import { IconFinanceArrowBoldDown16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { EPriceDiff } from '../../../../../containers/OfferHistory/types';

export interface IPriceProps extends React.PropsWithChildren {
  diff?: EPriceDiff;
  subprice?: string | null;
  size?: 'M' | 'XS';
}

export const Price: React.FC<IPriceProps> = ({ children, diff, subprice, size }) => {
  const Heading = size === 'M' ? UIHeading2 : UIHeading4;

  return (
    <div>
      <div className={styles['price']}>
        <Heading>{children}</Heading>
        {diff && diff !== EPriceDiff.NoChange && (
          <div style={{ transform: diff === EPriceDiff.Increase ? 'rotate(180deg)' : undefined }}>
            <IconFinanceArrowBoldDown16
              color={diff === EPriceDiff.Increase ? 'icon-negative-default' : 'icon-positive-default'}
              display="block"
            />
          </div>
        )}
      </div>
      {subprice && <UIText2 color="text-secondary-default">{subprice}</UIText2>}
    </div>
  );
};
